export default function Spacer({ width }) {
    const style = {
        display: "inline-block",
        width: width,
    };

    return <span style={style}></span>;
}
